/* eslint-disable import/no-unresolved */
import React, { FC, useEffect } from 'react';

import Head from 'next/head';
import { useSelector } from 'react-redux';
import { QueryClientProvider, QueryClient } from 'react-query';
import { AppProps } from 'next/dist/shared/lib/router/router';

import AppProvider from 'hooks';
import { IState, storeWrapper } from 'store';
import Interceptor from 'services/Interceptor';
import { LoaderOnRouteChange } from 'hooks/route';
import { IConfigApplicationProps } from 'store/modules/config';

import { Scripts } from 'components/common/Scripts';

import 'swiper/css';
import 'styles/reset.css';
import 'swiper/css/effect-fade';
import 'swiper/swiper-bundle.css';

// import BlackWeek from '../styles/blackWeek';
import GlobalStyle from 'styles/GlobalStyle';

const queryCliente = new QueryClient();

const WrappedApp: FC<AppProps> = ({ Component, pageProps }) => {
  const { ultraBlackFriday } = useSelector<IState, IConfigApplicationProps>(
    state => state.config.config,
  );

  useEffect(() => {
    if (ultraBlackFriday?.estaVigente) {
      // Remove qualquer <link> anterior
      const existingLink = document.getElementById('black-friday');
      if (existingLink) existingLink.remove();

      // Cria um novo <link> e adiciona ao <head>
      const link = document.createElement('link');
      link.id = 'black-friday';
      link.rel = 'stylesheet';
      link.href = ultraBlackFriday.linkCSS;
      document.head.appendChild(link);
    }
  }, [ultraBlackFriday]);

  return (
    <QueryClientProvider client={queryCliente}>
      <AppProvider>
        <Head>
          {process.env.NEXT_PUBLIC_SITE_BLINDADO && (
            <meta
              name="sb.validation_hash"
              content={process.env.NEXT_PUBLIC_SITE_BLINDADO}
            />
          )}
        </Head>

        <LoaderOnRouteChange />
        <Interceptor />
        <Scripts />

        <Component {...pageProps} />

        <GlobalStyle />
        {/* <BlackWeek /> */}
      </AppProvider>
    </QueryClientProvider>
  );
};

export default storeWrapper.withRedux(WrappedApp);
